/**
 * Tailwind class name composer.
 *
 * Combines clsx (conditional classes) with tailwind-merge (resolves
 * conflicts like `p-4 p-6` → `p-6` correctly). Used pervasively in
 * UI primitives and components for conditional styling.
 *
 * Usage:
 *   cn("px-4 py-2", isActive && "bg-accent-600", className)
 */

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
